import { defineMessages } from "react-intl";

export const messages = defineMessages({
  alreadyHasLabel: {
    id: "scheduleMeeting.form.createUser.alreadyHas.label",
    defaultMessage: "already has a meeting in that time",
    description: "label for create new patient",
  },
});
